import React, { useState, useEffect, useContext } from 'react';
import MasterPage from '@components/MasterPage';
import ListUserAccess from './components/ListUserAccess';
import Button from '@components/Button';
import { IUserAccess } from '@state/userAccess/types';
import * as T from './types';
import * as S from './styles';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '@state/types';
import WarningScreen from '@components/WarningScreen';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { UserAccessProvider } from '@utils/DOIgnition/UserAccessContex';
import { IUserType } from '@state/auth/types';
import UserModal from './components/UserModal';

const UserManagement: React.FC<T.IProps> = (props) => {
    const authContext = useContext(AuthContext);
    const hasPermissions = authContext.userData && authContext.userData.profile && (authContext.userData.profile.role === IUserType.ADMIN || authContext.userData.profile.role === IUserType.STAFF) && authContext.dsPermissions?.includes("USER_MANAGEMENT");

    const openNewTemplateState = useSelector<IAppState, IAppState["openNewTemplateState"]>((state) => state.openNewTemplateState).openNewTemplate;
    const history = useHistory();

    const [open, setOpen] = useState(false);
    const [userModalState, setUserModalState] = useState<T.IUserModalState>({});
    const [warningOptions, setWarningOptions] = useState({
      title: '',
      subtitle: '',
      actionTitle: '',
      actionFunction: () => {},
      closeActionTitle: '',
      errorNote: '',
      errorArguments: [],
    });
    const [noAdminDetected, setNoAdminDetected] = useState(false);

    useEffect(() => {
      if (!hasPermissions) {
        handleWarningScreen(
          true, "Unauthorized Page",
          `Please try to access Design Studio from a valid link in accordance with your user permissions. `,
          "", () => {history.push({pathname: '/'})}, "OKAY", "Unauthorized Page", []
        );
        setNoAdminDetected(true);
      }
    }, [])

    useEffect(() => {
      if (open === false && noAdminDetected === true) history.push({pathname: '/'});
    }, [open])

    const handleWarningScreen = (openValue:boolean, title:string, subtitle:string, actionTitle:string, actionFunction:any, closeActionTitle:string, errorNote:string, errorArguments: any) => {
      setOpen(openValue);
      setWarningOptions({
        title: title,
        subtitle: subtitle,
        actionTitle: actionTitle,
        actionFunction: actionFunction,
        closeActionTitle: closeActionTitle,
        errorNote: errorNote,
        errorArguments: errorArguments,
      })
    }

    const handleNewUserProfile = () => {
      setUserModalState({ action: "add" });  
    }

    const handleEditUserProfile = (userAccess: IUserAccess) => {
      setUserModalState({ action: "edit", userAccess })
    }

    return (
      <S.Root>
        <WarningScreen
          open={open}
          setOpen={setOpen}
          options={warningOptions}
        />
        <UserAccessProvider>
          {
            userModalState.action &&
            <UserModal
              action={userModalState.action}
              userModalStateProp={[userModalState, setUserModalState]}
            />
          }
          <MasterPage
            pageIndex={6}
            newHeight={300}
            renderAction={() => (
                <S.Header>
                  {
                    !openNewTemplateState &&
                    <Button
                        icon="add" 
                        label="USER PROFILE"
                        style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", width: 153, height: 36, boxSizing: 'border-box'}}
                        labelStyle={{color: "white", fontWeight: '500'}}
                        onClick={handleNewUserProfile}
                    />
                  }
                </S.Header>
            )}
          >
            {
              hasPermissions &&
                <ListUserAccess
                  handleWarningScreen={handleWarningScreen}
                  openModal={open}
                  editUser={handleEditUserProfile}
                />
            }
          </MasterPage>
        </UserAccessProvider>
      </S.Root>
    );
}

export default UserManagement;